import { useEffect, useState } from 'react'

import { useAppDispatch } from 'store'
import { CollectionActions } from 'store/pages/collection'

interface Props {
  collectionIds: number[]
}

const useBulkWalletEventCollectionData = (props: Props) => {
  const { collectionIds } = props

  const dispatch = useAppDispatch()

  const [collectionsFetchedAlready, setCollectionFetchedAlready] = useState<boolean>(false)

  useEffect(() => {
    if (!collectionsFetchedAlready) {
      dispatch(CollectionActions.getBulkData({ codes: collectionIds.map((x) => String(x)) }))

      for (const collectionId of collectionIds) {
        dispatch(CollectionActions.getEvents({ collectionId: String(collectionId), page: 0 }))
      }

      setCollectionFetchedAlready(true)
    }
  }, [collectionIds])
}

export default useBulkWalletEventCollectionData
